<template>
    <ManualSection :header="header" :open="open" :state="state" @click="$emit('click')">
        <template v-slot:comment>
            <p class="cmnt" v-if="verified">✓ Паспортные данные проверены.</p>
            <p class="cmnt" v-if="uploaded && false">Скан паспорта загружен.</p>
            <p class="cmnt" v-if="!uploaded && !verified && false">Загрузка скана не является обязательной, но мы должны иметь возможность проверить введённые паспортные данные. Вы можете предъявить паспорт лично, приехав к нам в офис.</p>
        </template>

        <PassportUpload v-if="false" commentPosition="none" :showUploadedComment="false" />
    </ManualSection>
</template>

<script>
import PassportUpload from './passportUpload.vue'
import ManualSection from '@/components/ManualSection.vue'

export default {
    props: {
        header: String,
        open: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        PassportUpload,
        ManualSection
    },
    computed: {
        uploaded() {
            return this.$store.getters.getUserData.memberInfo?.isPassportScanUploaded;
        },
        verified() {
            return this.$store.getters.getUserData.memberInfo?.isPassportDataVerified;
        },
        state() {
            return (this.uploaded || this.verified) ? 'success' : 'warning';
        },
    }
}
</script>
